// LLM:METADATA
// :topology: [Domain:Security | Role:Configuration | Pattern:ACL]
// :relates-to: required-by: "store/index.js"
// :rationale: "Central definition of user role permissions to declutter the store."
// :contract: pre: "None", post: "Exports permissions object"
// LLM:END

// Legacy frontend role matrix kept only as compatibility fallback while sessions without backend
// access_profile are still possible during bootstrap.
export const USER_ROLE_PERMISSIONS = {
  // Full access role - legacy/frontend key
  superadmin: {
    modules: true,
    reports: true,
    users: true,
    users_export: true,
    orders: true,
    cashbox: true,
    promocode_messages: true,
    shop_visits: true,
    oracle: true,
    oracle_reports: true,
    pages: true,
    services: true,
    carts: true,
    seo: true,
    options: true,
    shortUrl: true,
  },

  root: {
    modules: true,
    reports: true,
    users: true,
    users_export: true,
  },

  upr: {
    reports: true,
    modules: true,
    orders: true,
    services: true,
    oracle: true,
    oracle_reports: true,
    pages: true,
  },

  mm: {
    modules: [
      "lp",
      "cd",
      "acc_products",
      "labels",
      "artists",
      "suppliers",
      "countries",
      "youtube",
      "lp_album_tails",
      "cd_album_tails",
    ],
    packs: ["50", "52"],
    reports: ["store_pickup", "full_cat"],
    orders: true,
  },

  zakaz: {
    modules: ["lp", "cd", "acc_products"],
    packs: ["50"],
    orders: true,
    reports: ["store_pickup"],
  },

  vit: {
    reports: ["sales", "full_cat"],
  },

  photo: {
    modules: [
      "lp",
      "cd",
      "acc_products",
      "labels",
      "artists",
      "suppliers",
      "youtube",
      "lp_album_tails",
      "cd_album_tails",
      "sales",
    ],
    packs: ["52", "50", "51"],
    reports: [
      "photo_lp",
      "lp_no_keys",
      "photo_1c_copies",
      "full_cat",
      "artists",
      "top_artists",
      "photo_lp",
      "lp_no_keys",
      "photo_1c_copies",
      "add_copies",
    ],
  },

  cat_manager: {
    modules: [
      "lp",
      "cd",
      "acc_products",
      "labels",
      "artists",
      "countries",
      "lp_comments",
      "sales",
      "styles",
    ],
    packs: ["50", "52", "51"],
    reports: [
      "boxes_minus",
      "top_artists",
      "full_cat",
      "artists",
      "top_artists",
      "photo_lp",
      "lp_no_keys",
      "photo_1c_copies",
      "add_copies",
    ],
  },

  admin: {
    orders: true,
    cashbox: true,
    promocode_messages: true,
    shop_visits: true,
    oracle: true,
    oracle_reports: true,
    modules: true,
    pages: true,
    users_export: true,
    reports: [
      "preorders",
      "emails_qty",
      "emails_stat",
      "special",
      "sales",
      "orders",
      "cd_copies",
      "full_cat",
      "boxes_minus",
      "markets",
      "checks",
      "photo_lp",
      "lp_no_keys",
      "photo_1c_copies",
      "logs",
      "store_pickup",
      "product_sale_log",
      "bertus",
      "sales_speed",
      "repeated_products",
    ],
    users: true,
    services: true,
    carts: true,
    seo: true,
    options: true,
    shortUrl: true,
  },

  admin_king: {
    orders: true,
    cashbox: true,
    oracle: true,
    modules: true,
    pages: true,
    reports: true,
    users: true,
    services: true,
    carts: true,
    seo: true,
    options: true,
    oracle_reports: true,
    shortUrl: true,
    users_export: true,
  },

  zakupka: {
    orders: false,
    cashbox: false,
    oracle: true,
    modules: ["lp", "cd", "acc_products"],
    packs: ["50"],
    reports: ["sales", "full_cat", "search", "top_artists", "sales_speed"],
    users: false,
    services: false,
    carts: false,
    seo: false,
    options: false,
  },

  manager: {
    orders: true,
    oracle: true,
    carts: true,
    reports: ["store_pickup", "preorders"],
    shortUrl: true,
  },

  analyst: {
    // packs: true,
    modules: true,
    orders: true,
    oracle: true,
    cashbox: true,
    carts: true,
    reports: true,
    seo: true,
    options: true,
    users: true,
    services: true,
    pages: true,
  },

  seo: {
    pages: true,
    options: true,
    seo: true,
    modules: ["artists", "labels", "news", "articles"],
    packs: ["52", "49"],
  },
}

// Backend /api/auth may return admin_type = "super".
// Alias it to full-access ACL used by existing frontend checks.
USER_ROLE_PERMISSIONS.super = USER_ROLE_PERMISSIONS.superadmin
